<template>
  <div class="box">
    <div class="cardReplacement">
      <div class="conTent">
        <van-form @submit="onSubmit">
          <van-cell-group :border="false">
            <van-field
              input-align="right"
              v-model="baseinfo.abnormal"
              label="异常类型"
              required
              :rules="[{ required: true, message: '请输入' }]"
              :is-link="true"
              @click="showAbnormal = true"
              readonly
            />
            <van-popup v-model="showAbnormal" position="bottom">
              <van-picker
                show-toolbar
                :columns="columnsAbnormal"
                @confirm="onConAbnormal"
                @cancel="showAbnormal = false"
              />
            </van-popup>
          </van-cell-group>
          <van-cell-group :border="false">
            <van-field
              input-align="right"
              v-model="baseinfo.type"
              label="职位类型"
              required
              :rules="[{ required: true, message: '请输入' }]"
              :is-link="true"
              @click="showType = true"
              readonly
            />
            <van-popup v-model="showType" position="bottom">
              <van-picker
                show-toolbar
                :columns="columnsType"
                @confirm="onConType"
                @cancel="showType = false"
              />
            </van-popup>
          </van-cell-group>
          <van-cell-group :border="false" class="inpTime">
            <van-field
              type="date"
              input-align="right"
              label-width="80"
              v-model="baseinfo.time"
              label="签卡时间"
              required
              :rules="[{ required: true, message: '请输入' }]"
            />
            <van-field
              type="time"
              v-model="baseinfo.timeFen"
              :rules="[{ required: true, message: '请输入' }]"
            />
          </van-cell-group>
          <van-cell-group :border="false">
            <van-field
              input-align="right"
              placeholder="请输入补卡原因"
              v-model="baseinfo.abnormalReason"
              label="异常事由"
              type="textarea"
              required
              :rules="[{ required: true, message: '请输入' }]"
            />
          </van-cell-group>
          <div class="btnBox">
            <van-button round block type="info" native-type="submit" class="btn"
              >确认</van-button
            >
          </div>
          <!-- <div class="okBtn">
            <van-button block type="info" native-type="submit" class="btnCel"
              >提交</van-button
            >
          </div> -->
        </van-form>
        <div class="footer">
          <van-button round block class="btnClo" @click="cancel"
            >取消</van-button
          >
        </div>
      </div>
      <div class="footerImg">
        <img src="@/assets/time.svg" @click="toInfoList" alt="" />
        <div>补卡记录</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/apis";
import { getToken } from "@/utils/cookie";
export default {
  name: "cardReplacement",
  data() {
    return {
      baseinfo: {
        abnormal: "",
        type: "",
        time: "",
        abnormalReason: "",
        timeFen: "",
      },
      showAbnormal: false,
      showType: false,
      columnsAbnormal: [
        "因公：开会、班车延误、市内外出",
        "因私：个人原因刷卡异常",
      ],
      columnsType: ["普工", "主任以下职员", "主任级", "经理级"],
      key: [
        {
          value: "因公：开会、班车延误、市内外出",
          key: "option-1667960913124",
        },
        {
          value: "因私：个人原因刷卡异常",
          key: "option-1667960913125",
        },
        {
          value: "普工",
          key: "option-1667961231208",
        },
        {
          value: "主任以下职员",
          key: "option-1667961601521",
        },
        {
          value: "主任级",
          key: "option-1667961231209",
        },
        {
          value: "经理级",
          key: "option-1667961466608",
        },
      ],
    };
  },
  created() {
    const date = this.$route.query.data;
    this.baseinfo.time = date;
  },
  mounted() {},
  methods: {
    //提交
    onSubmit() {
      let str = this.key.find((item) => {
        return item.value == this.baseinfo.abnormal;
      });
      let org = this.key.find((item) => {
        return item.value == this.baseinfo.type;
      });
      let timeNew = this.baseinfo.time + " " + this.baseinfo.timeFen;
      let time = moment(timeNew).unix();
      let obj = {
        empNo: getToken(), //工号
        abnormalType: str.key, //异常类型
        positionType: org.key, //职位类型
        registrationCardDate: time, //签卡时间
        abnormalReason: this.baseinfo.abnormalReason, //异常事由
      };
      console.log(obj);
      api.addApplyevent(obj).then((data) => {
        console.log(data);
        this.$toast("申请成功");
        this.baseinfo = {
          abnormal: "",
          type: "",
          time: "",
          abnormalReason: "",
          timeFen: "",
        };
        this.$router.push({
          path: "/mobile/infoList",
          query: {},
        });
      });
    },
    //返回
    cancel() {
      this.$router.go(-1);
    },
    //选择异常类型
    onConAbnormal(value) {
      this.baseinfo.abnormal = value;
      this.showAbnormal = false;
    },
    //选择职位类型
    onConType(value) {
      this.baseinfo.type = value;
      this.showType = false;
    },
    //查看补卡记录
    toInfoList() {
      this.$router.push({
        path: "/mobile/infoList",
        query: {},
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .cardReplacement {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .cardReplacement {
    width: 276px * $zoom;
  }
}
.box {
  display: flex;
  justify-content: center;
}
.cardReplacement {
  font-size: 18px * $zoom;
  min-height: 100vh;
  background: #f4f5f8;
  position: relative;
  .conTent {
    flex: 1;
    // background: #fff;
  }
  ::v-deep .van-cell-group {
    background: #fff;
    margin-bottom: 5px * $zoom;
  }
  ::v-deep .van-cell {
    font-size: 10px * $zoom;
  }
  .inpTime {
    width: 100%;
    display: flex;
    align-items: center;
    background: #f4f5f8 !important;
    div:nth-child(1) {
      margin-right: 15px;
    }
    div:nth-child(2) {
      width: 270px;
    }
  }
}
.btnBox {
  width: 50%;
  position: absolute;
  bottom: 20px * $zoom;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px * $zoom 20px * $zoom;
  margin-left: 50%;
}
.btn {
  width: 80px * $zoom;
  font-size: 12pt;
  padding: 5px * $zoom;
}
.footer {
  width: 50%;
  position: absolute;
  bottom: 20px * $zoom;
  display: flex;
  justify-content: flex-end;
  padding: 10px * $zoom 20px * $zoom;
}
.btnClo {
  width: 80px * $zoom;
  font-size: 12pt;
  padding: 5px * $zoom;
  border: none;
}
.okBtn {
  width: 90%;
  position: absolute;
  left: 5%;
  top: 1200px;
  .btnCel {
    margin-top: 30px;
    border-radius: 10px;
    font-size: 26px;
  }
}
.footerImg {
  position: absolute;
  right: 30px;
  top: 55%;
  img {
    width: 100px;
  }
  div {
    font-size: 24px;
    margin-top: -20px;
    margin-left: 5px;
  }
}
::v-deep .van-picker__toolbar {
  height: 40px * $zoom;
  .van-picker__cancel {
    font-size: 0.42667rem;
  }
  .van-picker__confirm {
    font-size: 13px * $zoom;
  }
}
::v-deep .van-ellipsis {
  font-size: 12px * $zoom;
}
</style>
